export default __webpack_public_path__ + "static/media/offwrist.b443c470.svg";